import { render, staticRenderFns } from "./PrimaryCareManagement.vue?vue&type=template&id=c3217446&scoped=true"
import script from "./PrimaryCareManagement.vue?vue&type=script&lang=js"
export * from "./PrimaryCareManagement.vue?vue&type=script&lang=js"
import style0 from "./PrimaryCareManagement.vue?vue&type=style&index=0&id=c3217446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3217446",
  null
  
)

export default component.exports